export default {"src":"/_next/static/media/trusted-seller-icon.cbc3311b.svg","height":174,"width":120,"blurWidth":0,"blurHeight":0};